export default __webpack_public_path__ + "static/media/WaitWell.058671e4490132f2726cb390fafbc1bc.webp";